import { Box } from "@mui/material"
import type React from "react"
import { NWSS_EVENT_WINDOW_BAND_FILL } from "./NwssEventWindowLegend"
import {
  nwssEventWindowWeekSpan,
  type NwssEventWindow,
} from "./nwssEventWindow"
import { weekColumnLeftPercent } from "./nwssWeeklyGridLayout"

export interface NwssWeeklyEventWindowMarkersProps {
  weekKeys: readonly string[]
  eventWindow: NwssEventWindow
}

/** Light column wash for weeks inside the anomaly event window (no borders). */
export const NwssWeeklyEventWindowMarkers: React.FC<
  NwssWeeklyEventWindowMarkersProps
> = ({ weekKeys, eventWindow }) => {
  const span = nwssEventWindowWeekSpan(weekKeys, eventWindow)
  if (!span) return null

  const weekCount = weekKeys.length
  const left = weekColumnLeftPercent(span.startIndex, weekCount)
  const width = weekColumnLeftPercent(span.endIndex + 1, weekCount) - left

  return (
    <Box
      sx={{
        position: "absolute",
        left: `${left}%`,
        width: `${width}%`,
        top: 0,
        bottom: 0,
        bgcolor: NWSS_EVENT_WINDOW_BAND_FILL,
        pointerEvents: "none",
      }}
    />
  )
}
